import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isRecord } from '@cli-utils/shared.js'

export function isSlotArea(value: unknown): value is { fields: SchemaField[] } {
  return isRecord(value) && Array.isArray(value.fields)
}
